import type { UnifiedCustomer } from './workspaceStore';

/** Strip non-digits; return 10-digit mobile when valid. */
export function normalizeBorrowerPhone(raw: string | undefined | null): string | null {
  const digits = String(raw ?? '').replace(/\D/g, '');
  if (digits.length >= 10) return digits.slice(-10);
  if (digits.length >= 6) return digits;
  return null;
}

/** Human-readable borrower reference for UI and exports. */
export function computeCustomerDisplayRef(c: UnifiedCustomer, index: number): string {
  const phone = normalizeBorrowerPhone(c.phone);
  if (phone) return phone;
  const first = c.name.trim().split(/\s+/).filter(Boolean)[0];
  if (first) return `${first}-${String(index + 1).padStart(3, '0')}`;
  return `CUST-${String(index + 1).padStart(4, '0')}`;
}

/**
 * Resolve a stored payment `customerId` (may be legacy `hand:uuid`) to a clear label.
 */
export function resolveCustomerDisplay(
  customerId: string,
  customers: UnifiedCustomer[],
  recordId?: string
): string {
  const direct = customers.find((c) => c.id === customerId);
  if (direct) return direct.displayRef || direct.phone || direct.name;

  if (recordId) {
    const byFacility = customers.find((c) => c.facilities.some((f) => f.recordId === recordId));
    if (byFacility) return byFacility.displayRef || byFacility.phone || byFacility.name;
  }

  if (customerId.startsWith('ph:')) {
    const tail = customerId.slice(3);
    const phone = normalizeBorrowerPhone(tail);
    if (phone) return phone;
    if (!tail.startsWith('fin-') && !tail.startsWith('hl-')) return tail;
  }

  return '—';
}
